<template>
  <div>
    <nav
      v-if="currentRouteName != 'SecureHome'"
      class="navbar navbar-expand-lg navbar-light fixed-top topnav"
    >
      <div class="container topnav">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <a class="navbar-brand topnav">
            <router-link to="/" class="navbar-brand">EZRelic</router-link>
          </a>
          <button
            type="button"
            class="navbar-toggler"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-controls="bs-example-navbar-collapse-1"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav navbar-right ml-auto">
            <li v-if="currentRouteName == 'LandingHome'" class="nav-item">
              <a @click="scrollTo()" class="nav-link">HOME</a>
            </li>
            <li v-if="currentRouteName == 'LandingHome'" class="nav-item">
              <a @click="scrollTo('about')" class="nav-link">ABOUT</a>
            </li>
            <li v-if="currentRouteName == 'LandingHome'" class="nav-item">
              <a @click="scrollTo('howto')" class="nav-link">HOWTO</a>
            </li>
            <li v-if="currentRouteName == 'LandingHome'" class="nav-item">
              <a @click="scrollTo('examples')" class="nav-link">EXAMPLES</a>
            </li>
            <li v-if="currentRouteName == 'LandingHome'" class="nav-item">
              <a @click="scrollTo('contact')" class="nav-link">CONTACT</a>
            </li>
            <li>
              <router-link to="/login" class="nav-link">LOGIN</router-link>
            </li>
          </ul>
        </div>
        <!-- /.navbar-collapse -->
      </div>
    </nav>

    <nav
      v-if="currentRouteName == 'SecureHome'"
      class="navbar navbar-expand-lg navbar-light fixed-top"
      role="navigation"
      style="margin-bottom: 0"
    >
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggler"
          data-toggle="collapse"
          data-target=".navbar-collapse"
        >
          <span class="navbar-toggler-icon">Toggle navigation</span>
        </button>
        <a class="navbar-brand">
          <router-link to="/" class="navbar-brand">EZRelic</router-link>
        </a>
      </div>
      <!-- /.navbar-header -->

      <ul class="nav ml-auto navbar-right">
        <!-- /.dropdown -->
        <div class="dropdown">
          <a class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            <i class="fa fa-user fa-fw"></i>
            <!-- <i class="fa fa-caret-down"></i> -->
          </a>
          <ul class="dropdown-menu dropdown-menu-right dropdown-user">
            <a class="dropdown-item">
              <span @click="logout()">Logout</span>
            </a>
          </ul>
          <!-- /.dropdown-user -->
        </div>
        <!-- /.dropdown -->
      </ul>
      <!-- /.navbar-top-links -->
      <!-- /.navbar-static-side -->
    </nav>
  </div>
</template>

<style lang="css" scoped>
.logo {
  font-size: 200px;
}

.logo-small {
  font-size: 50px;
}

.navbar {
  font-family: Montserrat, sans-serif;
  margin-bottom: 0;
  background-color: #666666 !important;
  z-index: 9999;
  border: 0;
  font-size: 12px !important;
  line-height: 1.42857143 !important;
  letter-spacing: 4px;
  border-radius: 0;
}

.navbar li a,
.navbar .navbar-brand {
  color: #fff !important;
}

.navbar-nav li a:hover,
.navbar-nav li.active a {
  color: #000000 !important;
  background-color: #fff !important;
}

.navbar-default .navbar-toggle {
  border-color: transparent;
  color: #fff !important;
}
</style>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      currentRouteName: "LandingHome"
    };
  },
  methods: {
    logout: async function() {
      await this.$store.dispatch("logout");
      this.$router.push("/");
    },

    scrollTo: async function(el) {
      await this.$store.commit("SET_SCROLL_TO", el);
    }
  },
  watch: {
    $route(to) {
      this.currentRouteName = to.name || this.$router.currentRoute.name;
    }
  }
};
</script>